// One catalog lookup for the read-only list and the post-approval editor.
// Same brand code. When both sides have a publisher, they must match.
// A missing publisher_id on either side falls back only if that code has
// a single candidate, so another publisher's entry is not picked at random.
export const getDestinationName = (
  destinationsConfig: DestinationUrlsConfig[] | undefined,
  publisherId?: string,
  brand?: string
) => {
  if (!brand || !destinationsConfig?.length) return undefined

  const sameBrand = destinationsConfig.filter(item => item.code === brand)
  const samePublisher = sameBrand.filter(
    item =>
      !!publisherId && !!item.publisher_id && item.publisher_id === publisherId
  )

  if (samePublisher.length) return samePublisher[0].name

  const fallback = sameBrand.filter(item => !publisherId || !item.publisher_id)

  return fallback.length === 1 ? fallback[0].name : undefined
}
